
import { useNavigate } from 'react-router-dom';

export default function StockistCTA() {
  const navigate = useNavigate();

  return (
    <section id="stockist-cta" className="w-full bg-[#1A1A1A] py-16 md:py-24 px-4 md:px-8 lg:px-16">
      <div className="max-w-4xl mx-auto text-center">
        <h2
          className="text-[32px] md:text-[48px] font-bold text-white mb-4 md:mb-6"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Become a BEST Stockist
        </h2>
        <p
          className="text-[16px] md:text-[20px] text-[#DDDDDD] leading-relaxed mb-8 md:mb-10 max-w-2xl mx-auto"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Join our network of trusted retailers and distributors. Offer your customers the quality they demand with competitive trade pricing and dedicated support.
        </p>
        <div className="flex flex-col md:flex-row gap-4 md:gap-5 justify-center items-center">
          <button
            onClick={() => navigate('/contact')}
            className="bg-[#F2C612] text-[#1A1A1A] px-8 py-4 rounded text-[16px] font-semibold hover:shadow-lg transition-all duration-300 hover:-translate-y-1 whitespace-nowrap cursor-pointer w-full md:w-auto h-[58px] flex items-center justify-center"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Apply to Become a Stockist
          </button>
          <button
            onClick={() => navigate('/contact')}
            className="bg-transparent border-2 border-white text-white px-8 py-4 rounded text-[16px] font-semibold hover:bg-white hover:text-[#1A1A1A] transition-all duration-300 whitespace-nowrap cursor-pointer w-full md:w-auto h-[58px] flex items-center justify-center"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
}